/* eslint-disable arrow-body-style */
import { shallowEqual, useSelector } from "umi";
import moment from "moment";
import { findPageSelector } from "../components/NewFilter/util";
import { useMemo, useRef, useState } from "react";
import { FilterItemType } from "../types/dashboard";
import { getSelector } from "../services/dashboardSetting";
import { formatSortFiltersData } from "./_config/formatSortFiltersData";
import { getSystemFlag } from "../pages/overview/_config/system";
import { getSelectorMap } from "../_config/filterListMap";
import { getMediaChannelIcon, mediaChannelMap } from '@/pages/home/_config/mediaChannal';

// Platform 图标
import Default from '@/pages/home/assets/svg/dashboard/default.svg';

interface IProps {
  // 筛选器路径
  realPath:string;
  // 前端页面级默认筛选器
  pageDefaultSelector?: FilterItemType[];
  // 当后端配置了默认值，但是没有配置页面配置则直接使用前端配置（前端默认配置>后端默认配置）
  isUseFrontFilterConfig?: boolean;
  /** 追加到 new_selector 的 selector_list；可与 filterParamList 去重合并（如页面 inputList 上 allowMissingBackendKey 对应的 key） */
  extraFilterList?: string[];
  api?: string;
  visibleZeroReq?: boolean;
  otherParams?: {
    path: string;
  };
}

export const useNewSelectorParams = (props: IProps) => {
  const { realPath, pageDefaultSelector, isUseFrontFilterConfig, extraFilterList, api = '/api/v1/dashboard/new_selector', visibleZeroReq = false, otherParams } =  props || {};
  const { gameConfig, dataFrame, gameCode } = useSelector((state: any) => {
    return {
      gameConfig: state?.dashboardSetting?.gameConfig || {},
      dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
      gameCode: state.dashboard?.currentGame?.game_code
    };
  }, shallowEqual);
  const [loading, setLoading] = useState(true); // 筛选器loading

  const selectorRef = useRef<any>({
    gameCode,
  });

  // 和后端核核对后：
  // 1、不展示但是有默认值的筛选器也要传递过去
  // 2、沿用之前的兜底逻辑，后端不配置的时候，如果页面兜底展示的有对应的特殊筛选器，则也传递给后端
  // 3、传递多少筛选器，返回多少list
  const filterParamList = useMemo(()=>{
    const { default_selector: defaultSelector = [], page_selector: pageSelector = [] } = gameConfig || {};
    const filterParamConfig =  findPageSelector(realPath, pageSelector, defaultSelector,dataFrame, pageDefaultSelector, isUseFrontFilterConfig);

    if(visibleZeroReq) {
      return filterParamConfig?.filter(item => item?.visible === 1)?.map(item => item?.key) || [];
    } 
    return  filterParamConfig?.map(item => item?.key) || [];
  },[gameConfig, dataFrame, pageDefaultSelector, isUseFrontFilterConfig, realPath, visibleZeroReq]);
  
  // 获取selector
  const getSelectorInfo = () => {
    return new Promise((resolve) => {
      getSelector(
        gameCode,
        api,
        [...new Set([...(filterParamList || []), ...(extraFilterList || [])])],
        otherParams?.path || ''
      ).then(data => {
        const dataResult = formatSortFiltersData(data || {});
        if(dataFrame === 'pc') {
          dataResult.os_list = dataResult?.os_list?.map((item: any) => {
            const cleanedEnKey = item.os_name_en.toLowerCase().replace(/\s+/g, '');
            item.icon = getSystemFlag(cleanedEnKey) || Default;
            return item;
          });
        }
        if (dataResult?.ua_network) {
          dataResult.ua_network = dataResult.ua_network.map((item: any) => {
            const channelIcon = getMediaChannelIcon(item.name_en || item.code || '');
            item.icon = channelIcon === mediaChannelMap._default ? Default : channelIcon;
            return item;
          });
        }
        selectorRef.current = {
          ...dataResult,
          gameCode,
          latestDate: {
            date: data?.last_date?.daily_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
            hour: data?.last_date?.hour_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
            week: data?.last_date?.weekly_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
            month: data?.last_date?.monthly_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
          },
          selectorMap: getSelectorMap(dataResult)
        };
        resolve(selectorRef.current);
      }).catch(e => {
        console.log(e);
      }).finally(() => {
        setLoading(false);
      });
    });
  };

  return {
    loading,
    getSelectorList: getSelectorInfo,
  };
};